/**
 * CanvasGradient — the page ground for every tab.
 *
 * White at the top settling to limestone at the bottom, where the nav bar
 * The page holds white for the top ~40%, then falls to CANVAS_FLOOR and ENDS
 * there — where the deck pane (NAV_GRADIENT) picks up at the same value. The
 * up-sheen that used to lift the bottom back to white is retired: it erased
 * the floor and left the pane nothing to sit on. Both tokens live in
 * glassTokens so the join cannot drift.
 *
 * The colours come from the theme (`canvas.gradient`): in light that IS
 * CANVAS_GRADIENT, and in dark the canvas is the room.
 *
 * WHY A CHILD AND NOT A backgroundColor: a gradient is not a colour. The
 * screen's container keeps `flex: 1` and goes transparent; this mounts behind
 * the content as an absolute fill.
 *
 * WHY topInset EXISTS: Yoga insets absolute children by the parent's padding.
 * Three of the four tab screens pad their container by `insets.top`, so a
 * plain fill would start BELOW the status bar and leave an unpainted strip
 * there — the same trap RAMP_FILL exists to escape, except the offset here is
 * the safe-area inset (~59pt on a Pro), far past a fixed bleed. Pass the same
 * value the container pads by and the gradient reaches the true screen top,
 * which is also what keeps its white end where the eye expects it.
 *
 * pointerEvents="none" so it can never take a touch from the list above it.
 */
import React from 'react';
import { StyleSheet } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useTheme } from '../../theme';

export function CanvasGradient({ topInset = 0 }: { topInset?: number }) {
  const { palette } = useTheme();
  return (
    <LinearGradient
      colors={[...palette.canvas.gradient.colors]}
      // `locations` is part of the token: a mount that drops it reverts to a diffuse ramp.
      locations={palette.canvas.gradient.locations ? [...palette.canvas.gradient.locations] : undefined}
      start={palette.canvas.gradient.start}
      end={palette.canvas.gradient.end}
      style={[StyleSheet.absoluteFillObject, topInset ? { top: -topInset } : null]}
      pointerEvents="none"
    />
  );
}

export default CanvasGradient;
